﻿class JsFunctions {
    private static sidebar: HTMLElement = undefined;
    private static collapsedSidebar: HTMLElement = undefined;

    public static toggleSidebar() {
        window.document.body.classList.toggle('sidebar-toggled');
        if (!this.sidebar) {
            this.sidebar = window.document.querySelector('.sidebar');
            this.collapsedSidebar = window.document.querySelector('.sidebar .collapse');
        }
        this.sidebar.classList.toggle('toggled');
        if (this.sidebar.classList.contains('toggled') && this.collapsedSidebar) {
            this.collapsedSidebar.classList.toggle('hide');
        }
    }

    public static toggleHeadings(id:string) {
        const coll = document.getElementsByClassName('collapsibleNav');
        let i: number;

        for (i = 0; i < coll.length; i++) {
            if (coll[i].id == id) {

                var content = coll[i].nextElementSibling as HTMLElement;

                content.classList.toggle("hiddenNav");

                coll[i].classList.toggle("active");
            }
        }
    }

    public static async downloadFileStream(fileName, contentStreamReference) {
            const arrayBuffer = await contentStreamReference.arrayBuffer();
            const blob = new Blob([arrayBuffer]);
            const url = URL.createObjectURL(blob);
            const anchorElement = document.createElement('a');
            anchorElement.href = url;
            anchorElement.download = fileName ?? '';
            anchorElement.click();
            anchorElement.remove();
            URL.revokeObjectURL(url);
    }

    public static scrollToBottom(elementId: string) {
        const el = document.getElementById(elementId);
        if (el) {
            el.scrollTop = el.scrollHeight;
        }
    }

    public static triggerElementClick(id: string) {
        document.getElementById(id).click();
    }
}

(window as any).JsFunctions = JsFunctions;